import React from 'react';

import {fetchEventProgram} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadProgram = ({eventId, children, ...props}) => {
    useStoredDataChanged();
    return (
        <Loader {...props} skipSpinner={state => state.events[eventId]?.schedule.loaded} promises={[fetchEventProgram(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadProgram;
